import { findSpecByIssue } from '../pan-dir/specs.js';

export const findSpecByIssueThroughOverdeck = findSpecByIssue;

